import React from 'react';
import styles from './RoutesTable.module.css';
import { RouteStatusBadge } from './RouteStatusBadge';
import { ProfitScore } from './ProfitScore';
import { RouteItem } from '../routesTypes';
import { RowActionsMenu } from '../../../../components/RowActionsMenu';

interface RoutesTableProps {
  items: RouteItem[];
  onEdit?: (id: string) => void;
  onAddOrder?: (id: string) => void;
}

const formatCurrency = (value: number): string => {
  return '$' + value.toLocaleString();
};

const formatCost = (value: number): string => {
  return '$' + value.toFixed(2);
};

export const RoutesTable: React.FC<RoutesTableProps> = ({ items, onEdit, onAddOrder }) => {
  const showActions = !!(onEdit || onAddOrder);
  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.thRoute}>ROUTE</th>
            <th>DRIVER</th>
            <th>STATUS</th>
            <th className={styles.thRight}>PROFIT SCORE</th>
            <th className={styles.thRight}>REVENUE</th>
            <th className={styles.thRight}>COST/STOP</th>
            <th className={styles.thRight}>STOPS/HOUR</th>
            <th className={styles.thRight}>ON-TIME %</th>
            <th className={styles.thRight}>TOTAL STOPS</th>
            <th className={styles.thRight}>EST. TIME</th>
            {showActions && <th></th>}
          </tr>
        </thead>
        <tbody>
          {items.map((item) => {
            const isCostHigh = item.costPerStop >= 18;
            const isOnTimeHigh = item.onTimePercent >= 90;

            return (
              <tr key={item.id} className={styles.row}>
                <td className={styles.routeCell}>
                  <span className={styles.routeName}>{item.routeName}</span>
                  <span className={styles.routeCode}>{item.routeCode}</span>
                </td>
                <td className={styles.driverCell}>{item.driver}</td>
                <td>
                  <RouteStatusBadge status={item.status} />
                </td>
                <td className={styles.numericCell}>
                  <ProfitScore score={item.profitScore} trend={item.scoreTrend} />
                </td>
                <td className={styles.numericCell}>
                  {formatCurrency(item.revenue)}
                </td>
                <td className={`${styles.numericCell} ${isCostHigh ? styles.costHigh : styles.costLow}`}>
                  {formatCost(item.costPerStop)}
                </td>
                <td className={styles.numericCell}>
                  {item.stopsPerHour.toFixed(1)}
                </td>
                <td className={`${styles.numericCell} ${isOnTimeHigh ? styles.onTimeHigh : styles.onTimeLow}`}>
                  {item.onTimePercent}%
                </td>
                <td className={`${styles.numericCell} ${styles.totalStops}`}>
                  {item.totalStops}
                </td>
                <td className={styles.numericCell}>
                  {item.estTime}
                </td>
                {showActions && (
                  <td>
                    <RowActionsMenu
                      onEdit={onEdit ? () => onEdit(item.id) : undefined}
                      extra={onAddOrder ? [{ label: 'Add Order', onClick: () => onAddOrder(item.id) }] : undefined}
                    />
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
